import bannerImage from '../assets/img/slider-image.jpg';
import barksdaleLogo from '../assets/img/logo.bmp';
import extranetLogo from '../assets/img/logo_main.gif';
import technicalIssue from '../assets/img/technical_issue.png';
import InventoryIcon from '../assets/img/inventory.png';
import InventoryIconActive from '../assets/img/inventory_active.png';
import ResourcesIcon from '../assets/img/Vector (1).png';
import ResourcesIconActive from '../assets/img/Vector (1)_active.png';
import CompareSwitchIcon from '../assets/img/famicons_git-compare.png';
// import group from '../assets/img/Group 181.png';
import productConfigurator from '../assets/img/product_configurator.png';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CancelIcon from '@mui/icons-material/Cancel';
import UploadInventoryIcon from '../assets/img/icons8-upload-32.png';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import AnalyticsIcon from '@mui/icons-material/Analytics';

export const IMAGES = {
  bannerImage,
  barksdaleLogo,
  extranetLogo,
  technicalIssue,
  productConfigurator,
};

export const sidebarActions = [
  {
    disabled: true,
    label: 'Home',
    key: 'overview',
    path: '/dashboard',
    icon: < DashboardIcon sx = {{fontSize: '24px'}} />,
    activeIcon: < DashboardIcon sx = {{fontSize: '24px'}} /> 
  },
  // {
  //   disabled: true,
  //   label: 'Analytics',
  //   key: 'analytics',
  //   path: '/analytics',
  //   icon: <AnalyticsIcon sx={{fontSize: '24px'}} />,
  //   activeIcon: <AnalyticsIcon sx={{fontSize: '24px'}} />
  // }, 
  {
    disabled: true,
    label: 'Orders Management',
    key: 'oms',
    path: '/order-management-system',
    icon: <ShoppingCartIcon sx={{fontSize: '24px'}} />,
    activeIcon: <ShoppingCartIcon sx={{fontSize: '24px'}} />,
  },
  {
    disabled: true,
    label: 'Inventory',
    key: 'inventory',
    path: '/inventory',
    icon: < img src = {InventoryIcon} alt = "Inventory Icon" style = {{height: 22, marginLeft: '4px'}}/>,
    activeIcon: < img src = {InventoryIconActive} alt = "Inventory Icon" style = {{height: 22, marginLeft: '4px'}} />
  },
  {
    disabled: true,
    label: 'Admin',
    key: 'admin',
    path: '/admin',
    icon: < LockOutlinedIcon />,
    activeIcon: < LockOutlinedIcon />
  },
  {
    disabled: true,
    label: 'Sales Tools',
    key: 'resources',
    path: '/resources',
    icon: < img src = {ResourcesIcon} alt = "Resources Icon" style = {{ height: 20, marginLeft: '2px' }} />,
    activeIcon: <img src={ResourcesIconActive} alt="Resources Icon" style={{ height: 20, marginLeft: '2px' }} />
  },
  {
    disabled: true,
    label: 'Inventory Upload',
    key: 'uploadInventory',
    path: '/upload',
    icon: <img src={UploadInventoryIcon} alt="Upload Inventory" style={{ height: 22, marginLeft: '2px' }} />,
    activeIcon: < img src={UploadInventoryIcon} alt="Upload Inventory" style={{ height: 22, marginLeft: '2px' }} />
  },
  {
    disabled: true,
    label: 'Price Sheet',
    key: 'priceSheet',
    path: '/resources/resource-details/15',
    icon: <DescriptionIcon sx={{ fontSize: '24px' }} />,
    activeIcon: <DescriptionIcon sx={{ fontSize: '24px' }} />
  },
  {
    disabled: true,
    label: 'Obsolete Cross Reference',
    key: 'obsoleteCrossReference',
    path: '/resources/resource-details/21',
    icon: <CancelIcon sx={{ fontSize: '24px' }} />,
    activeIcon: <CancelIcon sx={{ fontSize: '24px' }} />
  },
  {
    disabled: true,
    label: 'Competitor Cross Reference',
    key: 'competitorCrossReference',
    path: '/resources/resource-details/62',
    icon: <CompareArrowsIcon sx={{ fontSize: '24px' }} />,
    activeIcon: <CompareArrowsIcon sx={{ fontSize: '24px' }} />
  },
  {
    disabled: true,
    label: 'Other Extranets',
    key: 'otherExtranet',
    path: '/otherextranet',
    icon: < DesktopWindowsOutlinedIcon />,
    activeIcon: < DesktopWindowsOutlinedIcon />,
  },
  {
    disabled: true,
    label: 'Compare a Switch',
    key: 'compareSwitch',
    path: '/compare-switch',
    icon: < img src = {CompareSwitchIcon} alt = "CompareSwitch Icon" style = {{ height: 22, marginLeft: '2px' } }/>,
    activeIcon: < img src = {CompareSwitchIcon} alt = "CompareSwitch Icon" style = {{ height: 22, marginLeft: '2px' } }/> 
  },
]